import { Link } from 'react-router-dom';
import type { SavedOrder } from '../../shared/menu';
import { formatPrice } from '../../shared/currencies';
import { useT } from '../lib/i18n';
import { relativeTime } from '../lib/relativeTime';

interface OrderListItemProps {
  order: SavedOrder;
}

export function OrderListItem({ order }: OrderListItemProps) {
  const t = useT();
  const itemCount = order.lines.reduce((acc, l) => acc + l.quantity, 0);
  return (
    <li>
      <Link
        to={`/orders/${order.id}`}
        style={{
          display: 'block',
          padding: 16,
          borderRadius: 12,
          background: 'var(--color-surface)',
          color: 'var(--color-primary)',
          textDecoration: 'none',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 4 }}>
          <div style={{ fontSize: 16, fontWeight: 500 }}>{order.restaurantName ?? 'Order'}</div>
          {order.total > 0 && (
            <div className="num" style={{ fontSize: 14, color: 'var(--color-text-secondary)' }}>
              {formatPrice(order.total, order.currency)}
            </div>
          )}
        </div>
        <div style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>
          {relativeTime(order.finalizedAt)}
          {' · '}
          {t('orders.itemCount').replace('{n}', String(itemCount))}
          {order.syncedAt === null && ' · ✓ on this device'}
        </div>
      </Link>
    </li>
  );
}
